<template>
  <div class="mb-3 row">
    <div class="col">
      <div class="bg-100 shadow-none border card">
        <div class="flex-between-center row gx-0">
          <div class="d-flex align-items-center col-sm-auto">
            <h5 class="mb-0 p-3 text-primary fw-bold">
              디바이스 관리<span class="text-info fw-medium" />
            </h5>
          </div>

          <div class="form-group d-flex align-items-end gap-2 p-3">
            <select
              id="selclient"
              v-model="selectClient"
              class="me-2 form-select-sm select-month form-select"
              style="width:160px; display:inline;"
              @change="onClientChange"
            >
              <option
                v-for="client in clientList"
                :key="client.clientcode"
                :value="client"
              >
                {{ client.clientname }}
              </option>
            </select>

            <a
              class="btn btn-falcon-default btn-sm"
              @click="handleReg"
            >
              <span
                class="mr-2 fs--2"
                data-fa-i2svg=""
              />등록
            </a>

            <a
              class="btn btn-falcon-default btn-sm"
              @click="handleUpdate"
            >
              <span
                class="mr-2 fs--2"
                data-fa-i2svg=""
              />수정
            </a>

            <a
              class="btn btn-falcon-default btn-sm"
              @click="handleDelete"
            >
              <span
                class="mr-2 fs--2"
                data-fa-i2svg=""
              />삭제
            </a>

            <a
              class="btn btn-falcon-default btn-sm"
              @click="handleConfigSetting"
            >
              <span
                class="mr-2 fs--2"
                data-fa-i2svg=""
              />제어변수 설정
            </a>

            <a
              v-if="user?.clientlevel === 0"
              class="btn btn-falcon-default btn-sm"
              @click="handleCalibSetting"
            >
              <span
                class="mr-2 fs--2"
                data-fa-i2svg=""
              />센서보정
            </a>
          </div>
        </div>  
      </div>     
    </div>
  </div>

  <div class="h-100 card">
    <div class="d-flex flex-between-center py-2 border-200 border-bottom card-header">
      <h6 class="mb-0">
        디바이스 리스트
      </h6>
    </div>
    <div class="d-flex align-items-center card-body">
      <div class="w-100">
        <CommGrid
          ref="commGridRef"
          :rows="loadResults"
          :columns="columnDefs"
          :is-check-box="true"
          :set-grid-height="null"
        />
      </div>
    </div>
  </div>

  <ConfigSettingModal
    v-if="ConfigShowModal && setdevice"
    :setdevice="setdevice"
    @close="ConfigShowModal = false"
  />

  <CalibSettingModal
    v-if="CalibShowModal && setdevice"
    :setdevice="setdevice"
    @close="CalibShowModal = false"
  />

  <DeviceManagerModal
    v-if="DeviceManagerShowModal"
    :selectclient="selectClient" 
    :setdevice="setdevice"
    :is-edit-mode="isEditMode"
    :slistjson="slistjson"
    @device-close="DeviceManagerShowModal = false" 
    @device-save="onDeviceManagerSave"
  />  

  <AlertModal ref="alertModalRef" />
  <ConfirmModal ref="confirmRef" />
</template>

<script setup lang="ts">

import axios from 'axios'
import CommGrid from '../components/CommGrid.vue'
import { onMounted, ref} from 'vue';
import type { Client, User, Device, ColumnDefinition } from '@/types/commontypes'
import ConfigSettingModal from '../components/ConfigSettingModal.vue'
import CalibSettingModal from '../components/CalibSettingModal.vue'
import DeviceManagerModal from '../components/DeviceManagerModal.vue'
import AlertModal from "@/components/AlertModal.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import moment from 'moment';

const clientList = ref<Client[]>([])
const deviceList = ref<Device[]>([])

const user = ref<User | null>(null)
const alertModalRef = ref();
const confirmRef = ref();
const isEditMode = ref(false)

const selectClient = ref<Client>({
    clientcode:'',
    clientname:'',
    clientlevel:0,
    servicestate:0,
    regdt:''
})

const loadResults = ref<Device[]>([]);
const columnDefs = ref<ColumnDefinition[]>([]);

const commGridRef  = ref();
const checkedRows = ref<Device[]>([]);

const ConfigShowModal = ref(false);
const CalibShowModal = ref(false);
const DeviceManagerShowModal = ref(false)
const setdevice = ref<Device | null>(null)
const slistjson = ref(null);

onMounted(async () => {
    const res = await axios.get('/api/userinfo', { withCredentials: true });
    user.value = res.data.user;

    // sdata define json read
    const response = await fetch("/sdatadefine.json");
    if (!response.ok) throw new Error("Failed to load JSON");
    const data = await response.json();
    console.log("sdatadefine json", data);
    slistjson.value = data;
    
    LoadClientList();
})

function LoadClientList() {
	if(!user.value)
		return;

    const userjson = user.value;
    if(!userjson)
        return;

	var clientid = "all";
	var clientlevel = 1;
	if(userjson.clientlevel == 0) {
		clientid = 'all';
		clientlevel = 1;
	} else {
		clientid = userjson.clientcode;
		clientlevel = 1;
	}

	// 입력값을 변수에 담고 문자열 형태로 변환
	const data = JSON.stringify({ 'operator': "getClientlist", 'clientid' : clientid, 'clientlevel' : clientlevel});
	
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		let result: Client[] = JSON.parse(xhr.responseText);
		// result = JSON.parse(result);

        result.sort((a, b) => {
            const a1 = a.clientname.toLowerCase();
            const b1 = b.clientname.toLowerCase();
            if (a1 < b1) return -1;
            if (a1 > b1) return 1;

            return 0;
        });

        clientList.value = [];
		for(let client of result) {
	        clientList.value.push(client);
    	}

        const savedClientCode = localStorage.getItem('selectedClientCode');
        let initialClient = clientList.value[0];
        // 저장된 client가 있고, 현재 리스트에 존재하면 해당 client 선택
        if (savedClientCode) {
            const foundClient = clientList.value.find(c => c.clientcode === savedClientCode);
            if (foundClient) {
                initialClient = foundClient;
            }
        }
		// 초기 측정기 리스트 로딩
		if( clientList.value.length > 0) {
            selectClient.value = initialClient
            LoadDeviceList();
		}
	});
}

function LoadDeviceList() {
  const data = JSON.stringify({ 'operator': "getDeviceDetaillist", 'clientcode' : selectClient.value.clientcode});

	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
    let result: Device[] = JSON.parse(xhr.responseText);
		const sortResult = result.sort((a, b) => a.devicename.localeCompare(b.devicename));
    deviceList.value = [...sortResult];
    loadResults.value = [...deviceList.value];

    getColumnInfo();
	});
}


// 날짜 포맷 함수
function formatDateTime(value: string|unknown) {
    if (!value) return '';
    return moment(value).format('YYYY-MM-DD HH:mm')
}

// 조회결과를 표시할 그리드의 컬럼정보를 구성함
function getColumnInfo() {
    const columnList: ColumnDefinition[] = [
        { field: 'dcode', label: '종류', labelClass: 'vgt-center-align', thClass: 'text-center', tdClass: 'text-center'},
        { field: 'deviceid', label: '아이디', labelClass: 'vgt-center-align', thClass: 'text-center', tdClass: 'text-center'},
        { field: 'devicename', label: '이름', thClass: 'text-center', tdClass: 'text-center'},
        { field: 'regdt', label: '등록날짜', thClass: 'text-center', tdClass: 'text-center', formatFn: formatDateTime},
        { field: 'configdt', label: '제어변수 설정날짜', thClass: 'text-center', tdClass: 'text-center', formatFn: formatDateTime},
        { field: 'configuse', label: '제어변수사용', thClass: 'text-center', tdClass: 'text-center'}
    ]

    columnDefs.value = [...columnList];
}


function onClientChange() {
    const selClientCode = selectClient.value.clientcode;
    localStorage.setItem('selectedClientCode', selClientCode);

    LoadDeviceList();
}


// 디바이스 등록
function handleReg() {
    setdevice.value = null;
    isEditMode.value = false;
    DeviceManagerShowModal.value = true;
}

function handleUpdate() {
    if(!commGridRef.value) {
        return;
    }
    
    checkedRows.value = commGridRef.value.selectedRows as Device[];
    if(!checkedRows.value || checkedRows.value.length <= 0) {
        alertModalRef.value.showAlertModal("경고", "수정할 디바이스를 선택하세요.");
        return;
    }

    if(checkedRows.value.length > 1) {
        alertModalRef.value.showAlertModal("경고", "1개의 디바이스만 선택해 주세요.");
        return;
    }

    isEditMode.value = true;
    setdevice.value = checkedRows.value[0] as Device;
    DeviceManagerShowModal.value = true;
}

async function handleDelete() {
    if (!commGridRef.value) return;

    checkedRows.value = commGridRef.value.selectedRows as Device[];
    if (!checkedRows.value || checkedRows.value.length <= 0) {
        alertModalRef.value.showAlertModal("경고", "삭제할 디바이스를 선택하세요.");
        return;
    }

    const names = checkedRows.value.map(d => d.devicename).join(', ');
    const ok = await confirmRef.value.showConfirmModal(
        "삭제 확인",
        `선택한 디바이스를 삭제하시겠습니까?<br><b>${names}</b>`
    );
    if (!ok) return;

    const deviceids = checkedRows.value.map(d => d.deviceid);
    const data = JSON.stringify({ 'operator': "deleteDevice", 'deviceid': deviceids });

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/ajax/ajaxcall');
    xhr.setRequestHeader('Content-type', "application/json");
    xhr.send(data);

    xhr.addEventListener('load', () => {
        const result = JSON.parse(xhr.responseText);
        if (result.err === 0) {
            LoadDeviceList();
        } else {
            alertModalRef.value.showAlertModal("경고", `디바이스 삭제가 실패했습니다. ${result.err}`);
        }
    });
}

function handleConfigSetting() {
    if (!commGridRef.value) {
        return;
    }

    checkedRows.value = commGridRef.value.selectedRows;
    if(checkedRows.value.length == 0) {
        alertModalRef.value.showAlertModal("경고", "제어변수를 설정할 디바이스를 선택하세요.");
        return;
    } else if(checkedRows.value.length > 1) {
        alertModalRef.value.showAlertModal("경고", "1개의 디바이스만 선택해 주세요.");
        return;
    }

    setdevice.value = checkedRows.value[0] as Device;
    ConfigShowModal.value = true;
}

function handleCalibSetting() {
    if (!commGridRef.value) {
        return;
    }

    checkedRows.value = commGridRef.value.selectedRows;
    if (checkedRows.value.length == 0) {
        alertModalRef.value.showAlertModal("경고", "센서보정을 설정할 디바이스를 선택하세요.");
        return;
    } else if (checkedRows.value.length > 1) {
        alertModalRef.value.showAlertModal("경고", "1개의 디바이스만 선택해 주세요.");
        return;
    }

    setdevice.value = checkedRows.value[0] as Device;
    CalibShowModal.value = true;
}

/**
 * 디바이스 설정 모달에서 저장 버튼 클릭시 부모에게 전달되는 이벤트 처리
 */
function onDeviceManagerSave() {
    DeviceManagerShowModal.value = false

    LoadDeviceList();
}


</script>

<style lang="">

</style>